import React, { ReactNode, useEffect, useMemo, useState } from "react";
import { AriaPopoverProps, DismissButton, Overlay, usePopover } from "react-aria";
import type { OverlayTriggerState } from "react-stately";
import * as S from "./styled";

type Props = AriaPopoverProps & {
    children: ReactNode;
    scrollingContainer?: Element;
    state: OverlayTriggerState;
    useTriggerWidth?: boolean;
};

const Popover = ({ children, scrollingContainer, state, useTriggerWidth = false, ...props }: Props) => {
    const { popoverProps, underlayProps } = usePopover(props, state);
    const [key, setKey] = useState(Date.now());
    const rect = useMemo(() => props.triggerRef.current?.getBoundingClientRect(), []);

    useEffect(() => {
        const handleScroll = () => {
            setKey(Date.now());
        };

        scrollingContainer?.addEventListener("scroll", handleScroll);

        return () => {
            scrollingContainer?.removeEventListener("scroll", handleScroll);
        };
    }, [scrollingContainer]);

    return (
        <Overlay key={key}>
            {!props.isNonModal && <S.Underlay {...underlayProps} />}
            <S.Popover
                {...popoverProps}
                ref={props.popoverRef as React.RefObject<HTMLDivElement>}
                column
                width={useTriggerWidth ? rect?.width : undefined}
            >
                {children}
                <DismissButton onDismiss={state.close} />
            </S.Popover>
        </Overlay>
    );
};

export default Popover;
